import { c as n, d as t } from "../../../index-34b1f277.js";
const { defineMultiStyleConfig: o, definePartsStyle: e } = n([
  "content",
  "control",
  "errorMessage",
  "label"
]), i = t({
  gap: 2,
  "& > button": {
    width: "100%",
    maxWidth: "140px"
  },
  "& > div:nth-of-type(1)": {
    minWidth: "58px",
    maxWidth: "70px"
  },
  "& > div:nth-of-type(2)": {
    minWidth: "70px",
    maxWidth: "70px"
  }
}), a = t({
  maxWidth: "fit-content"
}), r = t({
  marginTop: 1
}), l = t({
  marginBottom: 1,
  marginLeft: 0,
  marginRight: 0,
  marginTop: 0,
  fontWeight: 500,
  fontSize: "md",
  _invalid: {
    span: {
      color: "red.500"
    }
  }
}), s = e({
  content: i,
  control: a,
  errorMessage: r,
  label: l
}), c = {
  full: e({
    control: {
      maxWidth: "100%"
    },
    content: {
      "& > button": {
        maxWidth: "100%",
        flex: 1
      }
    }
  })
}, m = o({
  baseStyle: s,
  sizes: c
});
export {
  m as BirthdayPicker
};
//# sourceMappingURL=BirthdayPicker.es.js.map
